import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { PopupService } from '../../services/popup.service';

@Component({
    selector: 'app-refer',
    templateUrl: './refer.component.html',
    styleUrls: ['./refer.component.scss'],
    standalone: false
})
export class ReferComponent implements OnInit {
  url = '';
  readonly modalRef = inject(BsModalRef);
  private readonly popupService = inject(PopupService);
  private readonly translateService = inject(TranslateService);

  constructor() {}

  ngOnInit(): void {}

  copy() {
    this.popupService.messsageAlert('success', this.translateService.instant('misc.successCopy'));
  }
}
